export default __webpack_public_path__ + "static/media/Group9214.0edb3239.svg";